'use client';

import { css } from '@bts-web/utils-style-engine';
import { useClientTranslation } from '@bts-web/utils-lokalise';
import { Drawer } from '../../../common/contexts';
import StopOrderInfoSvg from './StopOrderInfoSvg';
import { useDrawerContext } from '../../../common/components/ModalDrawerContext/ModalDrawerContext';
import { ButtonBase } from '../../../common/components';

const StopOrderInfoDrawer = () => {
  const { closeDrawer } = useDrawerContext();

  const { t } = useClientTranslation();

  return (
    <Drawer>
      <div
        className={css({
          backgroundColor: 'neutrals.card_fill_primary',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          paddingBottom: 'small',
        })}
      >
        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            gap: 'medium',
            paddingX: 'medium',
            paddingTop: 'large',
          })}
        >
          <h1
            className={css({
              color: 'neutrals.text_primary',
              fontSize: 'headline.extra_large_semi_bold',
              fontWeight: 'headline.extra_large_semi_bold',
              letterSpacing: 'headline.extra_large_semi_bold',
              lineHeight: 'headline.extra_large_semi_bold',
            })}
          >
            {t('stop_order_info_title')}
          </h1>
          <p
            className={css({
              fontSize: 'body.medium',
              fontWeight: 'body.medium',
              letterSpacing: 'body.medium',
              lineHeight: 'body.medium',
            })}
          >
            {t('stop_order_info_subtitle_@tenant')}
          </p>
        </div>
        <StopOrderInfoSvg
          translations={{
            stopOrderInfoCurrentPriceLegend: t(
              'stop_order_info_current_price_legend',
            ),
            stopOrderInfoStopPriceLegend: t(
              'stop_order_info_stop_price_legend_@tenant',
            ),
          }}
        />
        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            gap: 'medium',
            paddingX: 'medium',
            paddingY: 'large',
            fontSize: 'body.medium',
            fontWeight: 'body.medium',
            letterSpacing: 'body.medium',
            lineHeight: 'body.medium',
          })}
        >
          <p>{t('stop_order_info_1_@tenant')}</p>
          <p>{t('stop_order_info_2_@tenant')}</p>
        </div>
        <div
          className={css({
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: 'auto',
            paddingX: 'medium',
          })}
        >
          <ButtonBase
            fullWidth
            size="large"
            visual="primary"
            onClick={() => closeDrawer()}
          >
            {t('got_it')}
          </ButtonBase>
        </div>
      </div>
    </Drawer>
  );
};

export { StopOrderInfoDrawer };
